import React from "react";
import { ensure } from "sprint-common-web";

import { RecordType } from "../../../../../common/types/RecordType";
import { AssetsAvailabilityList } from "../../../../common/components/listings/AssetsAvailabilityList";
import { OrderAssetAvailability } from "../../../../common/types/OrderAssetAvailability";
import { OrderAssetStorageType } from "../../../../common/types/OrderAssetStorageType";
import { OrderRequestListingItem } from "../../OrderRequestListingItem";

export const renderOrderRequestSoundtracks = (item?: OrderRequestListingItem): JSX.Element => {
    ensure(item);

    const hasAnyCloudAssetAvailable = item.soundtracks.cloud.some((soundtrack) =>
        [OrderAssetAvailability.FullMatch, OrderAssetAvailability.PartialMatch].includes(soundtrack.availability)
    );

    if (hasAnyCloudAssetAvailable) {
        return (
            <AssetsAvailabilityList
                items={item.soundtracks.cloud}
                type={OrderAssetStorageType.Cloud}
                testId={"order-requests-soundtracks-availability-status"}
                isTrailer={item.isTrailer}
                assetType={RecordType.Audio}
            />
        );
    }

    return (
        <AssetsAvailabilityList
            items={item.soundtracks.onPrem}
            type={OrderAssetStorageType.OnPrem}
            testId={"order-requests-soundtracks-availability-status"}
            isTrailer={item.isTrailer}
            assetType={RecordType.Audio}
        />
    );
};
